import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material';
import ModalForm from 'components/Form/ModalForm';

import { includesSSO } from 'helpers/helpers';
import { useSelector } from 'store/hooks';
import { useDeleteUser } from './hooks/useDeleteUser';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    userId: number;
};

const DeleteUserModal = ({ isOpen, onClose, userId }: Props): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isClientUsingSSO = useSelector((state) =>
        includesSSO(state.vision.client.authMethods),
    );
    const deleteUserMutation = useDeleteUser(userId);
    const secondaryMessage = isClientUsingSSO
        ? t('adminPanel.deleteSSO')
        : null;
    return (
        <ModalForm
            show={isOpen}
            closeModal={onClose}
            submit={() => deleteUserMutation.mutate()}
            submitText={t('common.delete')}
            title={t('common.deleteConfirm')}
            submitClass="e2e-confirm-delete-user-button"
            secondary={secondaryMessage}
            confirmButtonColor={theme.palette.red}
        />
    );
};

export default DeleteUserModal;
